//WMS - 供应商管理api
import {ServerDistApi} from '@/group-cloud/network/ServerBizApi';

export class WmsSupplierApi {

    constructor() {
    }
    protected static groupUrl = '/supplier';

    //获取供应商列表
    public static async getSupplierList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerDistApi.send(uri, data);
    }

    //获取所有供应商数据 不分页
    public static async getAllSupplierList(data) {
        let uri = this.groupUrl + '/all';
        return await ServerDistApi.send(uri, data);
    }
    //保存供应商
    public static async saveSupplier(data) {
        let uri = this.groupUrl +'/save';
        return await ServerDistApi.send(uri, data);
    }

    //获取供应商详情信息
    public static async getOneSupplier(data){
        let uri = this.groupUrl + '/get';
        return await ServerDistApi.get(uri, data);
    }

    //删除供应商
    public static async deleteSupplier(data){
        let uri = this.groupUrl + '/delete';
        return await ServerDistApi.get(uri, data);
    }
}


